import { asCurrency, asDate, asTimelessDate, CollapsableSection, Column, Columns, FormInput, FormLink } from "lqx-react";
import * as React from "react";
import { TransactionMovedUACActivity } from "api/activity";
import { Document } from "api/uploads";
import { CommentsCollapsable } from "./commentsSection";

export const TransactionMovedUACDetails = ({data, attachment, comment, currency} : {
    data : TransactionMovedUACActivity,
    attachment : Document,
    comment : string,
    currency: string,
}) => {
    return (
        <>
        <CommentsCollapsable attachment={attachment} comment={comment} />
        <CollapsableSection title="Transaction Details:" notExpanded>
            <Columns>
                <Column>
                    <FormInput label="Transaction Amount" value={asCurrency(data.transactionDetails.amount, currency)} />
                    <FormInput label="Statement Date" value={asTimelessDate(data.transactionDetails.statementDate)} />
                    <FormInput label="BAI Code" value={data.transactionDetails.baiCode} />
                </Column>
                <Column>
                    <FormInput label={data.movedToUAC ? "Unallocated Amount" : "Remaining Amount"} value={asCurrency(data.transactionDetails.unreconciledAmount, currency)} />
                    <FormInput label="Value Date" value={asTimelessDate(data.transactionDetails.valueDate)} />
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Customer Details:" notExpanded>
            <Columns>
                <Column>
                    <FormInput label="Customer Name" value={data.relationshipDetails.customerName} />
                </Column>
                <Column>
                    <FormInput label="Customer ID" value={data.relationshipDetails.customerId} />
                </Column>
            </Columns>
        </CollapsableSection>
        <CollapsableSection title="Supplier Details:" notExpanded>
            <Columns>
                <Column>
                    <FormInput label="Legal Entity Name" value={data.relationshipDetails.supplierLegalEntityName} />
                </Column>
                <Column>
                    <FormInput label="Company Code" value={data.relationshipDetails.supplierCompanyCode} />
                </Column>   
            </Columns>
        </CollapsableSection>
        </>
    );
}
